define('Components/OutdatedCampaignWidget/js/models/OutdatedCampaignWidgetInstanceModel',['jquery',
        'app',
        'WidgetInstanceModel',
        'UrlFactory'
    ],
    function ($, app, WidgetInstanceModel, UrlFactory) {
        return WidgetInstanceModel.extend({
            name:'OutdatedCampaignWidgetModel',
            mainText:function(){
                var t1 = app.t('Cette opération est terminée.', 'OutdatedCampaign'),
                    t2 = app.t(!app.getCustomer().isLogged() ? 'Ne ratez aucune actualité en vous inscrivant à notre newsletter !':'Ne ratez aucune nouveauté !', 'OutdatedCampaign');
                return t1+'<br/>'+t2;
            }
        })
    });
